import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { Amplify } from "aws-amplify";
import { awsConfig } from "./aws-config";
import toastPlugin from "./plugins/toast";
// import { awsConfigDev } from "./aws-config-dev";

// import awsConfigDev from "./aws-config-dev";
// import awsConfigPreprod from "./aws-config-preprod";
// import awsConfigProd from "./aws-config-prod";

// const getAwsConfig = () => {
//   console.log("Current Environment:", process.env.NODE_ENV);
//   console.log("App Environment:", process.env.VUE_APP_ENVIRONMENT);

//   switch (process.env.VUE_APP_ENVIRONMENT) {
//     case "development":
//       return awsConfigDev;
//     case "preprod":
//       return awsConfigPreprod;
//     case "production":
//       return awsConfigProd;
//     default:
//       console.warn(
//         "No environment specified, falling back to development config"
//       );
//       return awsConfigDev;
//   }
// };

// export const awsConfig = getAwsConfig();
// export const awsConfig = awsConfigDev;
console.log(
  "awsConfig - main  - userPoolClientId",
  awsConfig.Auth.Cognito.userPoolClientId
);
try {
  Amplify.configure(awsConfig);
  console.log("Amplify Configuration Success");
} catch (error) {
  console.error("Error configuring Amplify:", error);
}

// Initialize auth state from session storage
store.dispatch("initAuth");

createApp(App).use(store).use(router).use(toastPlugin).mount("#app");
